// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator {
  border-top: 1px solid #dee2e6;
  /*border-bottom: 1px solid #dee2e6;*/
  margin-top: 10px;
  margin-bottom: 10px;
}

.bg-oro {
  background-color: gold;
}

.bg-plata {
  background-color: silver;
}

.bg-bronce {
  background-color: rgb(205, 127, 50);
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Asociados/asociadosTable.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".separator {\n  border-top: 1px solid #dee2e6;\n  /*border-bottom: 1px solid #dee2e6;*/\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.bg-oro {\n  background-color: gold;\n}\n\n.bg-plata {\n  background-color: silver;\n}\n\n.bg-bronce {\n  background-color: rgb(205, 127, 50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
